import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { RightOutlined } from '@ant-design/icons';
import { Modal } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { currency, getStoreType } from "../../../../../dynamicController";
import { saveTransactionId, saveTransactionType } from "../../../../../redux/actions/paymentActions";

import io from 'socket.io-client';

import abaBank from "../../../../../assets/images/logo/ABABank.png";
// import alipay from "../../../../../assets/images/logo/Alipay.png";
// import jcb from "../../../../../assets/images/logo/JCB.png";
// import master from "../../../../../assets/images/logo/Master.png";
// import unionpay from "../../../../../assets/images/logo/UnionPay.png";
// import visa from "../../../../../assets/images/logo/VISA.png";
// import wechat from "../../../../../assets/images/logo/Wechat.png";
// import card from "../../../../../assets/images/logo/card_icons.png";

import insufficientToken from "../../../../../assets/images/icons/icn-creditInsufficient.png";

const STORETYPE = getStoreType()

const mySwal = withReactContent(Swal);

const Payway = ({ token, saveTransactionId, saveTransactionType, theme }) => {

    const [paymentAmount, setPaymentAmount] = useState("");
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState("");
    const [body, setBody] = useState([])
    const [formId, setFormId] = useState("")
    const [formName, setFormName] = useState("")
    const [target, setTarget] = useState("")
    const [user, setUser] = useState(null);
    const [selectedMethod, setSelectedMethod] = useState("");
    const [insufficientTokenModal, setInsufficientTokenModal] = useState(false)
    const [paymentConfirmationText, setPaymentConfirmationText] = useState("")
    const [paymentConfirmationModal, setPaymentConfirmationModal] = useState(false)
    const [cashPayment, setCashPayment] = useState(false)
    const [tokenPayment, setTokenPayment] = useState(false)
    const [khqrPayment, setKhqrPayment] = useState(false)
    const [openIframe, setOpenIframe] = useState(false)
    const [orderId, setOrderId] = useState("")
    // const [cardPayment, setCardPayment] = useState(false)
    // const [alipayPayment, setAlipayPayment] = useState(false)
    // const [wechatPayment, setWechatPayment] = useState(false)

    const formButtonClick = useRef();
    const { t } = useTranslation();

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.country && location.state.description && location.state.paymentAmount) {
            if (location.state.paymentAmount) {
                setPaymentAmount(location.state.paymentAmount)
            }

            if (location.state.user) {
                setUser(location.state.user)
            }

            if (location.state.user && location.state.pkg && token) {
                // reload token
                setKhqrPayment(true)
                // setCardPayment(true)
                // setAlipayPayment(true)
                // setWechatPayment(true)
            } else if (location.state.endPoint && location.state.sendThis) {
                // machine payment / Drop n Go
                if (location.state.sendThis.machine && location.state.sendThis.machine.epayment) {
                    setKhqrPayment(true)
                    // setCardPayment(true)
                    // setAlipayPayment(true)
                    // setWechatPayment(true)
                }
                if (location.state.user && location.state.user.tokenSetting) {
                    setTokenPayment(true)
                }
                if (location.state.sendThis.machine && location.state.sendThis.machine.cash) {
                    setCashPayment(true)
                }
            } else if (location.state.user && location.state.laundrypass && token) {
                // laundry pass purchase
                setKhqrPayment(true)
                // setCardPayment(true)
                // setAlipayPayment(true)
                // setWechatPayment(true)
            }
        } else {
            history.push("/")
        }
    }, []);

    useEffect(() => {
        if (body.length > 0) {
            formButtonClick.current.click();
        }
    }, [body]);

    useEffect(() => {
        if (orderId) {
            const socket = io({ transports: ['websocket'], auth: { transactionId: orderId } })
            socket.on("duitnowPayment", (transactionId) => {
                history.push("/")
            })

            return () => {
                socket.disconnect();
            };
        }
    }, [orderId])

    const checkTokenAmount = (method) => {
        if (method === "TOKEN" && (parseFloat(user.token) < parseFloat(paymentAmount))) {
            setInsufficientTokenModal(true)
        } else {
            if (method === "TOKEN") {
                setPaymentConfirmationText(<p className="text-center">{t("You have")} <strong>{user.token}</strong> {STORETYPE === "cleanpro" ? t("credits") : t("e-Tokens")}.<br />{t("Pay")} <strong>{parseFloat(paymentAmount)}</strong> {STORETYPE === "cleanpro" ? t("credits") : t("e-Tokens")} {("to")} <strong>{location.state.description}</strong>?</p>)
            } else {
                setPaymentConfirmationText(<p className="text-center">{t("Pay")} {currency(location.state.country)} {parseFloat(paymentAmount)} {t("to")} {location.state.description}?</p>)
            }
            setPaymentConfirmationModal(true)
        }
    }

    const handleKHQRPayment = () => {
        // const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        // if (isMobile || window.innerWidth <= 768) {
        //     setSelectedMethod("abapay_khqr_deeplink");
        //     confirmPayment("abapay_khqr_deeplink")
        // } else {
        setSelectedMethod("abapay_khqr");
        confirmPayment("abapay_khqr")
        // }
    }

    const confirmPayment = (paymentMethod) => {
        setLoading(true)
        if (location.state.user && location.state.pkg && token) {
            // reload token
            let sendThis = {
                userId: location.state.user.id,
                pkgId: location.state.pkg.id,
                type: "payway",
                paymentMethod,
                osPlatform: /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "IOS" : "ANDROID",
            }
            axios
                .post("/api/token/reload", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    saveTransactionType("Reload")
                    setLoading(false);
                    if (res.data.data.type === "form") {
                        setUrl(res.data.data.url)
                        if (res.data.data.formName) {
                            setFormName(res.data.data.formName)
                        }
                        if (res.data.data.target) {
                            setTarget(res.data.data.target)
                        }
                        if (res.data.data.id) {
                            setFormId(res.data.data.id)
                        }
                        if (res.data.data.orderId) {
                            setOrderId(res.data.data.orderId)
                        }
                        setBody(res.data.data.body)
                    } else if (paymentMethod === "abapay_khqr_deeplink") {
                        setTimeout(() => {
                            // redirect to deeplink url
                            window.location.href = res.data.data.url;
                        }, 500);

                        setTimeout(() => {
                            // if no bank app installed, redirect to checkout url
                            window.location.href = res.data.data.checkout_url;
                        }, 1000);
                    } else {
                        history.push("/thankyou");
                    }
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        } else if (location.state.endPoint && location.state.sendThis) {
            // machine payment / Drop n Go
            let sendThis = {
                ...location.state.sendThis,
                paymentMethod,
                osPlatform: /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "IOS" : "ANDROID",
            }

            if (paymentMethod === "TOKEN") {
                sendThis.token = true
            }

            if (paymentMethod === "CASH") {
                sendThis.cash = true
            }

            let headers = {
                "Content-Type": "application/json"
            }

            if (token) {
                headers = {
                    "Content-Type": "application/json",
                    "auth-token": token
                }
            }

            axios
                .post(location.state.endPoint, sendThis, { headers })
                .then(res => {
                    setLoading(false);
                    saveTransactionId(res.data.transactionId)
                    saveTransactionType("Transaction")
                    if (res.data.data?.type === "form") {
                        setUrl(res.data.data.url)
                        if (res.data.data.formName) {
                            setFormName(res.data.data.formName)
                        }
                        if (res.data.data.target) {
                            setTarget(res.data.data.target)
                        }
                        if (res.data.data.id) {
                            setFormId(res.data.data.id)
                        }
                        if (res.data.data.orderId) {
                            setOrderId(res.data.data.orderId)
                        }
                        setBody(res.data.data.body)
                    } else if (paymentMethod === "abapay_khqr_deeplink") {
                        setTimeout(() => {
                            window.location.href = res.data.data.url;
                        }, 500);

                        setTimeout(() => {
                            window.location.href = res.data.data.checkout_url;
                        }, 1000);
                    } else {
                        if (location.state.sendThis.kiosk) {
                            history.push("/kiosk")
                        } else if (location.state.sendThis.role === "staff") {
                            history.push("/staff")
                        } else {
                            history.push("/thankyou");
                        }
                    }
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        } else if (location.state.user && location.state.laundrypass && token) {
            // laundry pass purchase
            let sendThis = {
                userId: location.state.user.id,
                pkgId: location.state.laundrypass.id,
                paymentGateway: "payway",
                outletId: location.state.outletId,
                paymentMethod,
                osPlatform: /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "IOS" : "ANDROID",
            }

            axios
                .post("/api/subscription/purchase", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setLoading(false);
                    saveTransactionId(res.data.transactionId)
                    saveTransactionType("Subscription")
                    if (res.data.data.type === "form") {
                        setUrl(res.data.data.url)
                        if (res.data.data.formName) {
                            setFormName(res.data.data.formName)
                        }
                        if (res.data.data.target) {
                            setTarget(res.data.data.target)
                        }
                        if (res.data.data.id) {
                            setFormId(res.data.data.id)
                        }
                        if (res.data.data.orderId) {
                            setOrderId(res.data.data.orderId)
                        }
                        setBody(res.data.data.body)
                    } else if (paymentMethod === "abapay_khqr_deeplink") {
                        setTimeout(() => {
                            window.location.href = res.data.data.url;
                        }, 500);

                        setTimeout(() => {
                            window.location.href = res.data.data.checkout_url;
                        }, 1000);
                    } else {
                        history.push("/thankyou");
                    }
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        }
    }

    return (
        <div id="setting-page" className="user-faq">
            <div id="setting-main">
                <div id="user-header">
                    <h5><i onClick={e => history.goBack()} className="bi bi-chevron-left me-3"></i> <strong>Payway</strong></h5>
                </div>

                <div id="user-body" className="px-4">
                    <div className="form-group pt-3">
                        <h6>{t("Payment Amount")}</h6>
                        <p>{currency(location.state?.country)} {parseFloat(paymentAmount).toFixed(2)}</p>
                    </div>

                    <div className="form-group">
                        <h6>{t("Description")}</h6>
                        <p>{location.state.description}</p>
                    </div>

                    {
                        loading ? (
                            <div className="text-center">
                                <div
                                    className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`}
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="form-group">
                                <h6>{t("Choose way to pay")}</h6>
                                {
                                    cashPayment ? (
                                        <div className="d-flex" style={{ width: "95%", marginTop: "10px", height: "65px", border: "3px solid #B7BECB5C", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "10px" }} onClick={() => { setSelectedMethod("CASH"); checkTokenAmount("CASH") }}>
                                            <i className="bi bi-cash-coin" style={{ height: "40px", width: "40px", margin: "5px", borderRadius: "5px", fontSize: "x-large" }}></i>
                                            <div style={{ width: "90%" }}>
                                                <p style={{ marginBottom: "4px" }}>{t("Cash")}</p>
                                                <p style={{ fontSize: "12px", color: "#697386" }}>{t("Pay with cash")}</p>
                                            </div>
                                            <RightOutlined />
                                        </div>
                                    ) : null
                                }

                                {
                                    tokenPayment ? (
                                        <div className="d-flex" style={{ width: "95%", marginTop: "10px", height: "65px", border: "3px solid #B7BECB5C", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "10px" }} onClick={() => { setSelectedMethod("TOKEN"); checkTokenAmount("TOKEN") }}>
                                            <i className="bi bi-coin" style={{ height: "40px", width: "40px", margin: "5px", borderRadius: "5px", fontSize: "x-large" }}></i>
                                            <div style={{ width: "90%" }}>
                                                <p style={{ marginBottom: "4px" }}>E-token</p>
                                                <p style={{ fontSize: "12px", color: "#697386" }}>{t("Pay with e-token")}</p>
                                            </div>
                                            <RightOutlined />
                                        </div>
                                    ) : null
                                }

                                {
                                    khqrPayment ? (
                                        <div className="d-flex" style={{ width: "95%", marginTop: "10px", height: "65px", border: "3px solid #B7BECB5C", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "10px" }} onClick={() => handleKHQRPayment()}>
                                            <img src={abaBank} alt="ABA" style={{ height: "40px", marginRight: "10px", borderRadius: "5px" }} />
                                            <div style={{ width: "90%" }}>
                                                <p style={{ marginBottom: "4px" }}>ABA KHQR</p>
                                                <p style={{ fontSize: "12px", color: "#697386" }}>{t("Scan to pay with any banking app")}</p>
                                            </div>
                                            <RightOutlined />
                                        </div>
                                    ) : null
                                }

                                {/* {
                                    cardPayment ? (
                                        <div className="d-flex" style={{ width: "95%", marginTop: "10px", height: "65px", border: "3px solid #B7BECB5C", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "10px" }} onClick={() => { setSelectedMethod("cards"); confirmPayment("cards") }}>
                                            <img src={card} alt="card" style={{ height: "40px", marginRight: "10px", borderRadius: "5px" }} />
                                            <div style={{ width: "90%" }}>
                                                <p style={{ marginBottom: "4px" }}>Credit/Debit Card</p>
                                                <div className="d-flex">
                                                    <img src={visa} alt="visa" style={{ marginRight: "4px", height: "20px" }} />
                                                    <img src={master} alt="master" style={{ marginRight: "4px", height: "20px" }} />
                                                    <img src={unionpay} alt="unionpay" style={{ marginRight: "4px", height: "20px" }} />
                                                    <img src={jcb} alt="jcb" style={{ marginRight: "4px", height: "20px" }} />
                                                </div>
                                            </div>
                                            <RightOutlined />
                                        </div>
                                    ) : null
                                } */}

                                {/* {
                                    alipayPayment ? (
                                        <div className="d-flex" style={{ width: "95%", marginTop: "10px", height: "65px", border: "3px solid #B7BECB5C", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "10px" }} onClick={() => { setSelectedMethod("alipay"); confirmPayment("alipay") }}>
                                            <img src={alipay} alt="alipay" style={{ height: "40px", marginRight: "10px", borderRadius: "5px" }} />
                                            <div style={{ width: "90%" }}>
                                                <p style={{ marginBottom: "4px" }}>Alipay</p>
                                                <p style={{ fontSize: "12px", color: "#697386" }}>{t("Scan to pay with Alipay")}</p>
                                            </div>
                                            <RightOutlined />
                                        </div>
                                    ) : null
                                } */}

                                {/* {
                                    wechatPayment ? (
                                        <div className="d-flex" style={{ width: "95%", marginTop: "10px", height: "65px", border: "3px solid #B7BECB5C", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "10px" }} onClick={() => { setSelectedMethod("wechat"); confirmPayment("wechat") }}>
                                            <img src={wechat} alt="wechat" style={{ height: "40px", marginRight: "10px", borderRadius: "5px" }} />
                                            <div style={{ width: "90%" }}>
                                                <p style={{ marginBottom: "4px" }}>WeChat</p>
                                                <p style={{ fontSize: "12px", color: "#697386" }}>{t("Scan to pay with WeChat")}</p>
                                            </div>
                                            <RightOutlined />
                                        </div>
                                    ) : null
                                } */}

                                {/* <div className="d-flex" style={{ width: "95%", marginTop: "10px", height: "65px", border: "3px solid #B7BECB5C", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "10px"  }} onClick={() => {setSelectedMethod("google_pay"); confirmPayment("google_pay")}}>
                                    <img src={wechat} alt="google" style={{ height: "40px", marginRight: "10px", borderRadius: "5px" }} />
                                    <div style={{ width: "90%" }}>
                                        <p style={{ marginBottom: "4px" }}>Google Pay</p>
                                        <p style={{ fontSize: "12px", color: "#697386" }}>{t("Scan to pay with Google Pay")}</p>
                                    </div>
                                    <RightOutlined />
                                </div> */}
                            </div>
                        )
                    }

                    {
                        body.length > 0 ? (
                            <form action={url} method="post" target={target} id={formId} name={formName}>
                                {
                                    body.map((b, index) => (
                                        <input key={index} type="hidden" name={b.name} value={b.value} />
                                    ))
                                }
                                <input name="is_plugin_js" value="true" type="hidden" />
                                <input type="button" hidden value="Submit" ref={formButtonClick} onClick={(e) => AbaPayway?.checkout()} />
                            </form>
                        ) : null
                    }
                </div>
            </div>

            <Modal
                open={insufficientTokenModal}
                onCancel={(e) => setInsufficientTokenModal(false)}
                footer={null}
                closable={false}
                centered
            >
                <div className={theme}>
                    {
                        STORETYPE === "cleanpro" ? (
                            <img
                                className="d-block pb-3"
                                src={insufficientToken}
                                style={{ width: "64px", margin: "0 auto" }}
                                alt=""
                            />
                        ) : null
                    }
                    <h2 className="text-center pb-2">{STORETYPE === "cleanpro" ? t("Insufficient balance") : t("Insufficient e-Tokens")}</h2>
                    {STORETYPE === "cleanpro" ? <p className="text-center" style={{ fontSize: "16px", fontWeight: 300 }}>{t("Oops. You don't have enough balance to make the payment")}</p> : <p className="text-center">{t("Reload your e-token now?")}</p>}
                    <div className={`d-flex pt-3 justify-content-center ${STORETYPE === "cleanpro" ? "flex-row-reverse" : ""}`}>
                        <button id="cleanpro-topup-now" onClick={() => history.push("/user/reload")} className="btn btn-primary cleanpro-swal-btn washup-swal-btn mx-1 reload-token" style={{ backgroundColor: STORETYPE === "cleanpro" ? "#004FC1" : STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}>
                            {STORETYPE === "cleanpro" ? t("Topup now") : t("Reload now!")}
                        </button>
                        <button id="cleanpro-cancel-topup" onClick={() => setInsufficientTokenModal(false)} className="btn btn-secondary cleanpro-swal-secondary-btn washup-swal-btn mx-1 cancel-reload-token">
                            {STORETYPE === "cleanpro" ? t("Back") : t("Cancel")}
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
                open={paymentConfirmationModal}
                onCancel={(e) => setPaymentConfirmationModal(false)}
                footer={null}
                closable={false}
                centered
                maskClosable={false}
            >
                <div className={theme}>
                    <div className="text-center">
                        <i className="bi bi-question-circle" style={{ color: "#87adbd", fontSize: "70px" }}></i>
                    </div>
                    <h2 className="text-center pb-2">{t("Confirmation")}</h2>
                    {paymentConfirmationText ? <div>{paymentConfirmationText}</div> : null}
                    <div className={`d-flex pt-3 justify-content-center ${STORETYPE === "cleanpro" ? "flex-row-reverse" : ""}`}>
                        {
                            loading ? (
                                <div className="text-center">
                                    <div
                                        className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`}
                                        role="status"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-primary cleanpro-swal-btn washup-swal-btn mx-1"
                                        style={{ backgroundColor: STORETYPE === "washup" || STORETYPE === "jomcuci" ? "#004c64" : "#2778c4" }}
                                        onClick={(e) => confirmPayment(selectedMethod)}
                                        disabled={loading}
                                    >
                                        {STORETYPE === "cleanpro" ? t("Pay now") : t("OK")}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-secondary cleanpro-swal-secondary-btn washup-swal-btn mx-1"
                                        onClick={(e) => setPaymentConfirmationModal(false)}
                                    >
                                        {STORETYPE === "cleanpro" ? t("Cancel") : t("No")}
                                    </button>
                                </>
                            )
                        }
                    </div>
                </div>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.user.token,
        theme: state.theme.theme,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveTransactionId: (data) => dispatch(saveTransactionId(data)),
        saveTransactionType: (data) => dispatch(saveTransactionType(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Payway);